export const accessMap = [
    {
        key: "Full access",
        text: "Full access",
        entity: {
            create: true,
            read: true,
            update: true,
            delete: true,
            selfOnly: false,
            accessLists: true,
            manageLists: true,
            accessCharts: true,
            manageCharts: true
        },
        attribute: "Edit"
    },
    {
        key: "Read only",
        text: "Read only",
        entity: {
            create: false,
            read: true,
            update: false,
            delete: false,
            selfOnly: false,
            accessLists: true,
            manageLists: false,
            accessCharts: true,
            manageCharts: false
        },
        attribute: "Readonly"
    },
    {
        key: "Read only download",
        text: "Read only download",
        entity: {
            create: false,
            read: true,
            update: false,
            delete: false,
            selfOnly: false,
            accessLists: true,
            manageLists: false,
            accessCharts: true,
            manageCharts: false
        },
        attribute: "Readonly download"
    },
    {
        key: "No access",
        text: "No access",
        entity: {
            create: false,
            read: false,
            update: false,
            delete: false,
            selfOnly: false,
            accessLists: false,
            manageLists: false,
            accessCharts: false,
            manageCharts: false
        },
        attribute: "Hidden"
    },
    {
        key: "Self only",
        text: "Self only",
        entity: {
            create: true,
            read: true,
            update: true,
            delete: true,
            selfOnly: true,
            accessLists: false,
            manageLists: false,
            accessCharts: false,
            manageCharts: false
        },
        attribute: "Edit"
    },
]

export const attachmentAccessMap = [
    {
        key: "Full access",
        text: "Full access",
        attribute: "Edit"
    },
    {
        key: "Own files only",
        text: "Manage Own files only",
        attribute: "Edit own"
    },
    {
        key: "Read only downloadable",
        text: "Read only downloadable",
        attribute: "Readonly download"
    },
    {
        key: "Read only",
        text: "Read only",
        attribute: "Readonly"
    },
    {
        key: "No access",
        text: "No access",
        attribute: "Hidden"
    }
]
